import React from 'react'
import { ModalSeeker, TextFieldSeeker, ButtonLoadingSeeker } from '@ui-seeker/core'
import { Grid, Divider } from '@mui/material'
import { useSignal } from '@preact/signals-react'
import { leadingOpenUrlModal } from 'Pages/BusinessLogistics/LeadingAnalyzer/Page/@signals'
import { useLeadingUrlModalSubmit } from 'Pages/BusinessLogistics/LeadingAnalyzer/Page/@hooks'


export default function LeadingUrlModal() {

	const urlName = useSignal('')
	const { isLoading, setIsLoading } = useLeadingUrlModalSubmit(urlName.value)

	return <ModalSeeker
		hideActions
		isOpen={!!leadingOpenUrlModal.value}
		title={'Url name'}
		containerProps={{ maxWidth: 'sm', p: 2 }}
		controller={() => leadingOpenUrlModal.value = null}
	>
		<Grid container spacing={1}>
			<Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<TextFieldSeeker
					label="Custom Name for the Url"
					value={urlName.value}
					onChange={e => urlName.value = e.target.value}
				/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ width: '100%', my: 2 }}/>
			</Grid>
			<Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<ButtonLoadingSeeker
					loading={isLoading}
					onClick={setIsLoading}
				>
					Confirm
				</ButtonLoadingSeeker>
			</Grid>
			<Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<ButtonLoadingSeeker
					onClick={() => leadingOpenUrlModal.value = false}
				>
					Cancel
				</ButtonLoadingSeeker>
			</Grid>
		</Grid>
	</ModalSeeker>
}